export default {
  getProcessesNumber (processList, processId) {
    let result = 'No tiene PP'
    try {
      let process = processList.find(item => item.id === processId)
      if (process) {
        result = process.processNumber
      }
    } catch (error) {
      console.error('[Method: getProcessesNumber]', error)
    }
    return result
  }
}
